import { render, staticRenderFns } from "./diseaseGraph.vue?vue&type=template&id=48bf612d&scoped=true&"
import script from "./diseaseGraph.vue?vue&type=script&lang=js&"
export * from "./diseaseGraph.vue?vue&type=script&lang=js&"
import style0 from "./diseaseGraph.vue?vue&type=style&index=0&id=48bf612d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bf612d",
  null
  
)

export default component.exports